module.exports = __webpack_public_path__ + "img/icon-rocket.e8587c28.svg";